import React, { FC, forwardRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import clsx from 'classnames';
import { AiOutlineClose } from 'react-icons/ai';

import styles from './modal.module.scss';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const Modal: FC<any> = forwardRef(({ show = false, ...props }, ref) => {
  const [display, setDisplay] = React.useState(false);
  const { className, onClose, title } = props;

  const close = () => {
    setDisplay(false);
    onClose?.();
  };

  useEffect(() => {
    setDisplay(show);
  }, [show, setDisplay]);

  if (display) {
    return ReactDOM.createPortal(
      <>
        <div className={styles.modalOverlay} />
        <div aria-hidden aria-modal className={styles.modalWrapper} role="dialog" tabIndex={-1}>
          <div className={clsx(styles.modal, className)}>
            <div className={styles.modalHeader}>
              <h3 className="modal-title text-center font-semibold">{title}</h3>
              <span
                aria-label="Close"
                className={clsx('btn btn-outline-light cursor-pointer')}
                data-dismiss="modal"
                onClick={close}>
                <AiOutlineClose className="inline-icon" color="white" />
              </span>
            </div>

            <div className="m-4 modal-body overflow-auto">{props.children({ close })}</div>
          </div>
        </div>
      </>,
      // @ts-ignore
      document.getElementById('modal-root'),
    );
  }

  return <div />;
});
